exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-ota-style {\n  line-height: 40px;\n  padding: 0 15px 0 10px;\n  height: 40px;\n  cursor: pointer; }\n  .dropdown-ota-style.off {\n    pointer-events: none; }\n  .dropdown-ota-style.text-left {\n    text-align: left; }\n  .dropdown-ota-style.error {\n    border-color: #ed1c24; }\n  .dropdown-ota-style:focus {\n    border-color: #003a90; }\n  .dropdown-ota-style.disabled {\n    background-color: #f5f5f5;\n    cursor: not-allowed;\n    pointer-events: none; }\n  .dropdown-ota-style img {\n    width: 16px;\n    height: 16px;\n    margin-right: 5px;\n    position: relative;\n    top: -1px; }\n  .dropdown-ota-style a, .dropdown-ota-style a:hover {\n    line-height: 32px;\n    color: #061021; }\n\n.item-list {\n  overflow: hidden; }\n\n.d-none {\n  display: none; }\n\n.dropdown-sub-menu {\n  width: unset;\n  max-width: unset; }\n  .dropdown-sub-menu li :hover {\n    cursor: pointer;\n    background-color: red; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/icon-dropdown/icon-dropdown.component.scss
// module id = 899
// module chunks = 22